module.exports = __webpack_public_path__ + "img/attribute4.ebcf8f73.png";